// ensure all the needed assets are loaded
import.meta.glob(['../../../images/**', '../../../fonts/**', '../../../icons/**']);
import EvEmitter from 'ev-emitter';
import '../shared/sections';
import '../shared/components';
import { loadAll } from '../../utils/sections/registration.js';

class App extends EvEmitter {
  constructor() {
    super();

    this.app = document.getElementById('main');
    loadAll(this.app);
  }
}

window.WL = window.WL || {};
window.WL.app = new App();
